<template>
  <div class="candidate-spa-root">
    <div
      v-if="!authShellRevealed"
      class="auth-shell-wait"
      aria-busy="true"
      aria-live="polite"
      role="status"
    />
    <div
      v-else
      data-auth-layout-root
      class="auth-layout-root"
      :class="[authRoleClass, { 'app-shell--candidate-auth': isCandidateAuthShell }]"
    >
      <BaseLayout>
        <router-view />
      </BaseLayout>
    </div>
  </div>
</template>

<script setup lang="ts">
import { appAuthPresentation, authShellRevealed } from '@/utils/authMe';
import { computed } from 'vue';
import BaseLayout from '../BaseLayout.vue';

const authRoleClass = computed(() => {
  const v = appAuthPresentation.value;
  if (v === true) return 'is-logged-in';
  if (v === false) return 'is-guest';
  return 'is-auth-pending';
});

const isCandidateAuthShell =
  typeof document !== 'undefined' && document.body?.dataset.appShell === 'candidate-auth';
</script>

<style scoped lang="scss">
@import '@/assets/stylesheets/components/_variables.scss';

.candidate-spa-root {
  min-height: 100vh;
}

/**
 * グローバルフッター等が先に見えてガタつくのを防ぐため、初回のみビューポート全面で待機する。
 * SP 固定ヘッダー（$z-navigation）より手前に置く。
 */
.auth-shell-wait {
  position: fixed;
  inset: 0;
  z-index: $z-loading-overlay;
  background-color: $bg-silver-primary;
}
</style>
